if (!customElements.get("sticky-atc")) {
  class StickyATC extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.stickyATCUpper = document.querySelector(".section-main-product .product-form__submit");

      if (!this.stickyATCUpper) return;

      this.button = this.querySelector("[data-sticky-atc-btn]");

      document.documentElement.style.setProperty("--footer-offset", `${this.offsetHeight}px`);

      new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.2 }).observe(this.stickyATCUpper);

      this.button.addEventListener("click", this.onClickHandler.bind(this));
    }

    disconnectedCallback() {
      if (!this.stickyATCUpper) return;

      // disconnect IntersectionObserver
      const observer = new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.2 });
      observer.unobserve(this.stickyATCUpper);
    }

    handleUpperIntersect(entries, observer) {
      this.colorSelector = this.querySelector(".product__color-selector");
      this.variantSelector = this.querySelector(".product__variant-selector");

      entries.forEach((entry) => {
        // Only run this on desktop (window width 989px or wider)
        if (window.innerWidth >= 989) {
          if (entry.isIntersecting) {
            // hide sticky-atc when scrolling up
            document.querySelector("sticky-atc").style.transform = "translateY(calc(100% + var(--space-24)))";
            const gnattaChat = document.querySelector(".gnattaChat");
            if (gnattaChat) {
              gnattaChat.style.transform = "translateY(0px)";
            }
            this.variantSelector?.classList.remove("active");
            this.colorSelector?.classList.remove("active");
          } else {
            // show sticky-atc when scrolling down
            document.querySelector("sticky-atc").style.transform = "translateY(0)";
            const gnattaChat = document.querySelector(".gnattaChat");
            if (gnattaChat) {
              gnattaChat.style.transform = "translateY(-80px)";
            }
            this.variantSelector?.classList.remove("active");
            this.colorSelector?.classList.remove("active");
          }
        }
      });
    }

    onClickHandler(event) {
      event.preventDefault();
      var mainAtc = document.querySelector("product-form .product-form__submit");
      if (mainAtc) {
        mainAtc.click();
      }
    }

    onClickHandlerMobile(event) {
      event.preventDefault();
      // Scroll to top on mobile devices
      if (window.innerWidth < 750) {
        window.scroll({ top: 0, behavior: "smooth" });
      }
    }
  }

  customElements.define("sticky-atc", StickyATC);
}
